import { isAfter, subMinutes } from 'date-fns';

const NEW_USER_THRESHOLD_IN_MINUTES = 10;

export const isNewUser = (createdAt: string | number): boolean => {
  const threshold = subMinutes(Date.now(), NEW_USER_THRESHOLD_IN_MINUTES);
  return isAfter(new Date(createdAt), threshold);
};
